import { render, staticRenderFns } from "./SelectMajorPage.vue?vue&type=template&id=5ff037a4&scoped=true&"
import script from "./SelectMajorPage.vue?vue&type=script&lang=js&"
export * from "./SelectMajorPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectMajorPage.vue?vue&type=style&index=0&id=5ff037a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff037a4",
  null
  
)

export default component.exports